module.exports = "https://venezia-network.servercdn.it/static/fonts/FuturaPT-Demi.ttf?cc2af0787cb4b6579c8de6cdb7e0ec19";